module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配课程顾问"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.uid + ' - ' + item.nickName) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.adviserParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "adviserId", $$v)
      },
      expression: "adviserParam.adviserId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-158f201d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/AssignAdviserTreModal.vue
// module id = 1658
// module chunks = 8